import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useSocket } from '../hooks/useSocket';

const menu = [
  { to: '/',              icon: '📊', label: 'Dashboard' },
  { to: '/monitoramento', icon: '👁️', label: 'Monitoramento' },
  { to: '/mensagens',     icon: '💬', label: 'Mensagens' },
  { to: '/atendentes',    icon: '👤', label: 'Atendentes' },
  { to: '/contatos',      icon: '📋', label: 'Contatos' },
  { to: '/conversas',     icon: '🗂️', label: 'Conversas' },
  { to: '/produtividade', icon: '📈', label: 'Produtividade' },
  { to: '/alertas',       icon: '🔔', label: 'Alertas' },
  { to: '/gestor',        icon: '🤖', label: 'Gestor IA' },
  { to: '/campanhas',     icon: '📢', label: 'Campanhas' },
  { to: '/transcricoes',  icon: '🎙️', label: 'Transcrições' },
  { to: '/substituto',    icon: '🔄', label: 'Substituto IA' },
  { to: '/kanban',        icon: '📋', label: 'CRM Kanban' },
  { to: '/flowbuilder',   icon: '⚡', label: 'Flow Builder' },
];

const s = {
  app:     { display:'flex', minHeight:'100vh', background:'#0f172a', color:'#f1f5f9' },
  sidebar: { width:220, background:'#1e293b', display:'flex', flexDirection:'column',
             borderRight:'1px solid #334155', flexShrink:0 },
  logo:    { padding:'24px 20px 20px', borderBottom:'1px solid #334155' },
  logoTxt: { fontSize:18, fontWeight:700, color:'#38bdf8' },
  logoSub: { fontSize:11, color:'#64748b', marginTop:4 },
  nav:     { flex:1, padding:'12px 0' },
  navLnk:  { display:'flex', alignItems:'center', gap:10, padding:'10px 20px',
             color:'#94a3b8', textDecoration:'none', fontSize:14, transition:'all .15s',
             borderLeft:'3px solid transparent' },
  navAct:  { color:'#38bdf8', background:'rgba(56,189,248,.08)', borderLeftColor:'#38bdf8' },
  footer:  { padding:'16px 20px', borderTop:'1px solid #334155', fontSize:12, color:'#475569' },
  main:    { flex:1, display:'flex', flexDirection:'column', overflow:'auto' },
  header:  { background:'#1e293b', borderBottom:'1px solid #334155',
             padding:'14px 28px', display:'flex', alignItems:'center',
             justifyContent:'space-between' },
  hRight:  { display:'flex', alignItems:'center', gap:16 },
  dot:     (ok) => ({ width:8, height:8, borderRadius:'50%',
             background: ok ? '#22c55e' : '#ef4444', display:'inline-block', marginRight:4 }),
  badge:   { background:'#ef4444', color:'#fff', borderRadius:12,
             padding:'2px 8px', fontSize:11, fontWeight:700 },
  content: { flex:1, padding:'28px', overflowY:'auto' },
  logoutBtn: { background:'none', border:'1px solid #334155', color:'#94a3b8',
               borderRadius:8, padding:'6px 14px', cursor:'pointer', fontSize:13 }
};

export default function Layout({ children }) {
  const { admin, logout } = useAuth();
  const { connected, alertas } = useSocket();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={s.app}>
      <aside style={s.sidebar}>
        <div style={s.logo}>
          <div style={s.logoTxt}>WaFlow Admin</div>
          <div style={s.logoSub}>Painel de controle</div>
        </div>
        <nav style={s.nav}>
          {menu.map(item => (
            <NavLink key={item.to} to={item.to} end={item.to === '/'}
              style={({ isActive }) => ({ ...s.navLnk, ...(isActive ? s.navAct : {}) })}>
              <span>{item.icon}</span>
              <span>{item.label}</span>
              {item.to === '/alertas' && alertas.length > 0 && (
                <span style={{ ...s.badge, marginLeft:'auto' }}>{alertas.length}</span>
              )}
            </NavLink>
          ))}
        </nav>
        <div style={s.footer}>
          <div>{admin?.name}</div>
          <div style={{ color:'#334155', fontSize:11 }}>{admin?.role}</div>
        </div>
      </aside>

      <main style={s.main}>
        <header style={s.header}>
          <div style={{ fontSize:13, color:'#64748b' }}>
            <span style={s.dot(connected)} />
            {connected ? 'Tempo real ativo' : 'Reconectando...'}
          </div>
          <div style={s.hRight}>
            <span style={{ fontSize:13, color:'#94a3b8' }}>{admin?.email}</span>
            <button style={s.logoutBtn} onClick={handleLogout}>Sair</button>
          </div>
        </header>
        <div style={s.content}>{children}</div>
      </main>
    </div>
  );
}
